import theme from "../../materialThemeOverrides";
const { primary, grey } = theme.palette;

export const navStyle = {
    navBar: {
        height: "100%",
        flexDirection: "column",
        minWidth: 120,
        position: "relative"
    },
    selected: {
        fontWeight: "bold",
        color: primary["300"],
        // backgroundColor: grey[800],
        "& .material-icons": {
            color: primary[300]
        },
        "& label": {
            color: primary[200]
        }
    },
    navItem: {
        color: "#fff",
        padding: "20px 8px",
        textAlign: "center",
        transition: "all 400ms ease-in",
        "& label": {
            textTransform: "uppercase",
            fontSize: 12
        },
        "& span": {
            display: "block",
            marginBottom: 4,
            fontSize: 24,
            width: "auto"
        },
        "&:first-child": {
            paddingTop: 24
        },
        "&:last-child": {
            paddingBottom: 28,
            marginBottom: 0
        },
        "&:hover": {
            "& .material-icons": {
                color: primary[400]
            },
            "& label": {
                color: primary[400]
            }
        }
    },
    bottom: {},
    lastTop: {
        flexGrow: 1
    },
    bottomNav: {
        position: "absolute",
        bottom: 0,
        width: "100%",
        paddingBottom: 10
    },
    round: {
        overflow: "hidden",
        borderTopRightRadius: 40,
        borderBottomRightRadius: 40,
        backgroundColor: grey["700"]
    }
};
